


































import Vue from 'vue';

import settingsPannel from '../settings.vue';

import { MDCRipple } from '@material/ripple';

import Axios from 'axios';

import postComponent from '../../post.vue';

export class Post {
  public ID: string = '';
  public ImageID: string = '';
  public Title: string = '';
  public SubTitle: string = '';
  public Paragraphs: string[] = [];
  public Date: Date = new Date();

  public parseSameObject(input: any) {
    this.ID = input.ID;
    this.ImageID = input.ImageID;
    this.Title = input.Title;
    this.SubTitle = input.SubTitle;
    this.Paragraphs = input.Paragraphs;
    this.Date = input.Date;
  }
}

interface Data {
  posts: Post[];
}

export default Vue.extend({
  name: 'blog',
  data(): Data {
    return {
      posts: [],
    };
  },
  mounted() {
    this.initMDC();
    this.getBlogPosts();
  },
  methods: {
    getBlogPosts() {
      const v = this;
      Axios.get('/API/posts').then((resp: any) => {
        // Order the list of posts
        resp.data.sort((a: Post, b: Post) => {
          if (a.Date < b.Date) {
            return 1;
          }
          if (a.Date > b.Date) {
            return -1;
          }
          return 0;
        });

        v.posts = resp.data;
      });
    },
    initMDC() {
      const buttons = this.$el.querySelectorAll('.mdc-button') as NodeListOf<HTMLElement>;
      for (const button of buttons) {
        const buttonRipple = new MDCRipple(button);
      }
    },
  },
  components: {
    postComponent,
    settingsPannel,
  },
});
